module.exports = __webpack_public_path__ + "img/37.acac9138.png";